import { render } from "./DFList.vue?vue&type=template&id=5592e9cc&scoped=true"
import script from "./DFList.vue?vue&type=script&lang=js"
export * from "./DFList.vue?vue&type=script&lang=js"

import "./DFList.vue?vue&type=style&index=0&id=5592e9cc&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5592e9cc"]])

export default __exports__